import { forwardRef } from 'react';
import { useReduxState } from 'hooks';

interface Props {
  handleToggle: () => void;
  isActive: boolean;
  style?: React.CSSProperties;
}

const RequireAllToggle = forwardRef<HTMLButtonElement, Props>(
  ({ handleToggle, isActive, ...props }, ref) => {
    const { messages, theme } = useReduxState();

    return (
      <button
        {...props} // Radix's props needed for keyboard navigation, must be before onClick
        className={`switch focus-box-shadow ${isActive ? 'switch-active' : ''}`}
        onClick={handleToggle}
        ref={ref}
        type="button"
      >
        <div className="switch-icon focus-box-shadow-child">
          <div className="switch-icon-inner" />
        </div>
        <div className="switch-label">
          {messages.filtersIsInAllSwitchMessage}
        </div>

        <style jsx>{`
          .switch {
            background-color: transparent;
            border: 0;
            color: ${theme.textColorLighter};
            cursor: pointer;
            display: inline-flex;
            font-family: inherit;
            font-size: 1.3rem;
            font-weight: 600;
            gap: 5px;
            margin: 0;
            outline: 0;
            padding: 0;
            text-align: left;
          }
          .switch-icon {
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 20px;
            display: inline-block;
            flex-shrink: 0;
            font-weight: 400;
            padding: 2px;
            position: relative;
            transition: background-color 0.3s;
            height: ${12 + 6}px;
            width: ${12 * 2 + 6}px;
          }
          .switch-icon-inner {
            background-color: rgba(0, 0, 0, 0.2);
            border-radius: 20px;
            display: inline-block;
            position: absolute;
            top: 3px;
            left: 3px;
            transition: all 0.3s;
            height: 12px;
            width: 12px;
          }
          .switch:focus .switch-icon {
            box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.15);
          }
          .switch:hover .switch-icon-inner {
            background-color: rgba(0, 0, 0, 0.3);
          }
          .switch.switch-active .switch-icon {
            background-color: ${theme.successColor};
          }
          .switch.switch-active .switch-icon-inner {
            background-color: ${theme.successTextColor};
            left: 50%;
          }
        `}</style>
      </button>
    );
  }
);

RequireAllToggle.displayName = 'RequireAllToggle';

export default RequireAllToggle;
